import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexContainer, FlexRow } from 'styles/layouts';

export const ImageWrapper = styled(FlexContainer)<{
  aspectRatio: string;
  legacyStyles: boolean;
}>`
  position: relative;
  width: 100%;
  align-self: center;
  justify-items: center;

  ${({ legacyStyles }) =>
    !legacyStyles &&
    `
      border-radius: 20px;
      border: 1px solid ${themeStyle.varTransparentMain5};
    `}

  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  overflow: hidden;
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding: 0;
  overflow: hidden;

  border-radius: 20px;
  border: 12px solid ${themeStyle.varBackgroundAlt};
  box-shadow: ${themeStyle.varShadowSmallHeavy};
`;

export const Video = styled.video`
  display: block;
  width: 100%;
  height: auto;
`;

export const VideoControls = styled(FlexRow)`
  gap: 5px;
  align-items: center;
  position: absolute;
  bottom: 12px;
  left: 12px;
  width: calc(100% - 24px);
  height: 33px;
  padding: 4px 12px 4px 0;
  background-color: ${themeStyle.varBackgroundAlt};
  backdrop-filter: blur(81.5485px);
  border-radius: ${themeStyle.radiusMedium};
`;

export const PlayButton = styled.button`
  height: 100%;
  padding-left: 12px;
  background: transparent;
  border: none;
  cursor: pointer;

  svg {
    fill: ${themeStyle.varBlueMain};
  }
`;

export const ProgressBar = styled.input`
  width: 100%;
  height: 5px;
  -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
  background: transparent;
  margin: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: ${themeStyle.varBlueMain};
    cursor: pointer;
    margin-top: -5px;
  }

  &::-moz-range-thumb {
    -webkit-appearance: none;
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: ${themeStyle.varBlueMain};
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: ${themeStyle.varInkLight};
    border-radius: 16px;
  }

  &:focus::-webkit-slider-runnable-track {
    background: ${themeStyle.varInkLight};
  }

  &::-moz-range-track {
    width: 100%;
    height: 5px;
    cursor: pointer;
    background: ${themeStyle.varInkLight};
    border-radius: 16px;
  }
`;

export const YoutubeIframe = styled.iframe`
  width: 100%;
  max-width: 100%;
  /* all Youtube embeds are shown as 16:9 ratio. this enforces responsive height on iframe */
  aspect-ratio: 16 / 9;
`;
